import { loadState } from '@nextcloud/initial-state';
import { t, n } from '@nextcloud/l10n';
import Vue from 'vue';
import DeclarativeSection from './components/DeclarativeSettings/DeclarativeSection.vue';
import logger from './logger';
const forms = loadState('settings', 'declarative-settings-forms', []);
/**
 * @param forms The forms to render
 */
function renderDeclarativeSettingsSections(forms) {
    Vue.mixin({ methods: { t, n } });
    const DeclarativeSettingsSection = Vue.extend(DeclarativeSection);
    return forms.map((form) => {
        const el = `#${form.app}_${form.id}`;
        return new DeclarativeSettingsSection({
            el,
            propsData: {
                form,
            },
        });
    });
}
document.addEventListener('DOMContentLoaded', () => {
    logger.debug('Loaded declarative forms', { forms });
    renderDeclarativeSettingsSections(forms);
});
